// extracted by mini-css-extract-plugin
export var content = "_3z-3";
export var list = "_3z-4";
export var settingsContent = "_3z-7";
export var settingsPanel = "_3z-8";
export var state = "_3z-6";
export var triggerBadge = "_3z-2";
export var triggerButton = "_3z-1";
export var triggerShell = "_3z-0";
export var unreadDot = "_3z-5";